module.exports = __webpack_public_path__ + "static/circle-5c53791f192bb444f3c15054923570c5.svg";